import { render, staticRenderFns } from "./SecurityLocalizationProviderItem.vue?vue&type=template&id=5020cbe7&lang=pug&"
import script from "./SecurityLocalizationProviderItem.vue?vue&type=script&lang=js&"
export * from "./SecurityLocalizationProviderItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports